<template>
  <div class="position-list clearfix">
    <div class="table-section fr">
      <Search @getHeight="getHeight"
              @add="addPos"
              @saveSet="saveSet"
              ref="Search"
              width="350px"
              :isquery="true"
              :tableConfig="tableConfig"
              :tableName="tableName"
              :sortPara="sortPara"
              :delPara="delPara"
              :functionBtn="true"
              :showSort="false"
              searchName="getPostsData">
        <template v-slot:left>
          <el-col :lg="24"
                  :md="24"
                  :sm="24"
                  :xs="24">
            <el-form-item label="关键字">
              <el-input @keyup.enter.native="$refs.Search.handleSearch"
                        v-model="searchForm.keyWord"
                        clearable
                        placeholder="请输入关键字查询"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="12"
                  :md="12"
                  :sm="12"
                  :xs="12">
            <el-form-item label="发布类型">
              <el-select v-model="searchForm.releaseType"
                         clearable
                         style="width: 100%"
                         placeholder="请选择发布类型">
                <el-option v-for="item in statusList"
                           :key="item.Value"
                           :label="item.value"
                           :value="item.num"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </template>
        <template v-slot:center>
          <el-button size="small "
                     type="success"
                     plain
                     @click="batchState(1)"
                     icon="el-icon-edit-outline"
                     v-if="verifyPermission('Update')">批量发布职位</el-button>
          <el-button size="small "
                     type="success"
                     plain
                     @click="batchState(2)"
                     icon="el-icon-edit-outline"
                     v-if="verifyPermission('Update')">批量公共职位</el-button>
          <el-button size="mini"
                     icon="el-icon-back"
                     type="warning"
                     plain
                     v-if="verifyPermission('Update') && $route.query.needBack"
                     @click="$router.go(-1)">返回招聘报名</el-button>
        </template>
        <template v-slot:advancedQuery>
          <el-col :lg="5"
                  :md="6"
                  :sm="12"
                  :xs="24">
            <el-form-item label="企业简称">
              <el-select filterable
                         v-model="searchForm.enterpriseId"
                         clearable
                         style="width: 100%"
                         placeholder="请选择企业简称">
                <el-option v-for="item in companyList"
                           :key="item.Id"
                           :label="item.shortName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="4"
                  :md="6"
                  :sm="12"
                  :xs="24">
            <el-form-item label="类型">
              <el-select v-model="searchForm.remunerationType"
                         clearable
                         style="width: 100%"
                         placeholder="请选择类型">
                <el-option v-for="item in remunerationTypeList"
                           :key="item.id"
                           :label="item.label"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="4"
                  :md="6"
                  :sm="12"
                  :xs="24">
            <el-form-item label="职位类别">
              <el-select v-model="searchForm.positionType"
                         clearable
                         style="width: 100%"
                         placeholder="请选择职位类别">
                <el-option v-for="item in typeList"
                           :key="item.value"
                           :label="item.text"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </template>
      </Search>
      <div class="page">
        <MyTable @selectionChange="handleSelectionChange"
                 @sortChange="sortChange"
                 @selectChange="selectChange"
                 @inputChange="inputChange"
                 :tableData="tableData"
                 :tableConfig="tableConfig"
                 :height="tableHeight"
                 :indexFlag="true"
                 tableEmptyText="暂无数据，点击新增"
                 @EmptyBtn="addPos"
                 tableType="selection">
          <template v-slot:index="slotData">
            {{
              ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
              slotData.scope.$index +
              1
            }}
          </template>
          <template v-slot:time="slotData">
            {{
              slotData.scope.row.updateDate &&
              slotData.scope.row.updateDate.slice(0, 16)
            }}
          </template>

          <template v-slot:perk="slotData">
            <el-tag size="small"
                    type="success"
                    v-if="slotData.scope.row.subsidyCount > 0">有</el-tag>
            <el-tag size="small"
                    type="danger"
                    v-else>无</el-tag>
          </template>
          <template v-slot:remunerationType="slotData">
            {{ posType(slotData.scope.row.remunerationType) }}
          </template>
          <template v-slot:refreshDate="slotData">
            {{
            slotData.scope.row.refreshDate &&
            slotData.scope.row.refreshDate.slice(0, 10)
          }}
          </template>
          <template v-slot:dateTimeTo="slotData">
            {{
            slotData.scope.row.dateTimeTo &&
            slotData.scope.row.dateTimeTo.slice(0, 10)
          }}
          </template>
          <template v-slot:isPublic="slotData">
            <el-tag size="small"
                    type="success"
                    v-if="slotData.scope.row.isPublic">是</el-tag>
            <el-tag size="small"
                    type="danger"
                    v-else>否</el-tag>
          </template>
          <template v-slot:dateTimeFrom="slotData">
            {{
            slotData.scope.row.dateTimeFrom &&
            slotData.scope.row.dateTimeFrom.slice(0, 10)
          }}
          </template>
          <template v-slot:sort="slotData">
            <el-input-number size="small"
                             v-model="slotData.scope.row.sort"
                             controls-position="right"
                             :precision="0"
                             @change="slotData.scope.row.add = '1'"></el-input-number>
          </template>

          <template v-slot:operation="slotData">
            <el-button @click="editPost(slotData.scope.row)"
                       size="small"
                       icon="el-icon-edit"
                       v-if="verifyPermission('Update')">编辑</el-button>
            <!-- <el-button @click="openDialog(slotData.scope.row)"
                       size="small"
                       icon="el-icon-picture"
                       v-if="verifyPermission('Update')">二维码入职</el-button> -->
            <!-- <el-button
              @click="deletePosition(slotData.scope.row)"
              type="danger"
              plain
              size="small"
              icon="el-icon-delete"
              v-if="verifyPermission('Delete')"
              >删除</el-button
            > -->
            <el-button @click="UpdateTime(slotData.scope.row.id)"
                       type="primary"
                       plain
                       size="small"
                       icon="el-icon-refresh"
                       v-if="verifyPermission('Update')">刷新时间</el-button>
            <el-button @click="openDialog(slotData.scope.row)"
                       type="primary"
                       plain
                       size="small"
                       icon="el-icon-picture"
                       v-if="verifyPermission('Update')">小程序分享</el-button>
          </template>
        </MyTable>
        <Pagination class="PagPosition"
                    :total="total"
                    @getNewData="getPostsData"
                    ref="pagination" />
      </div>

      <el-dialog :title="batchNum == 1 ? '批量发布' : '批量公共职位'"
                 :visible.sync="stateDialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="400px"
                 class="colleague-dialog"
                 @close="resetForm">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules"
                 label-width="auto"
                 v-enterToNext="true">
          <el-col :span="24"
                  v-if="batchNum == 1">
            <el-form-item label="职位生效"
                          prop="dateTimeFrom">
              <el-date-picker v-model="form.dateTimeFrom"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="startDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>

            <!-- 职位结束日期（限制：必须大于开始日期） -->
            <el-form-item label="职位结束">
              <el-date-picker v-model="form.dateTimeTo"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              :picker-options="endDatePickerOptions"
                              @change="handleDateChange"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24"
                  v-if="batchNum == 2">
            <el-form-item label="公共职位"
                          prop="isPublic">
              <el-select v-model="form.isPublic"
                         placeholder="请选择">
                <el-option label="是"
                           :value="true">
                </el-option>
                <el-option label="否"
                           :value="false">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                resetForm();
                stateDialogVisible = false;
              }
            ">取 消</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="changeState('form')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog title="小程序码录入"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center>
      <div style="display: flex; justify-content: center">
        <img :src="imgPath"
             alt=""
             v-if="$shareType == 2" />
        <div id="qrcode"
             ref="qrcode"
             v-if="$shareType == 1"></div>
      </div>
    </el-dialog>
    <AddPosition :drawerShow="addPositionDrawerShow"
                 :postInfo="postInfo"
                 :operation="operation"
                 @colseDrawer="addPositionDrawerShow = false"
                 @refreshData="getPostsData()" />

    <!-- <PerkManage :visible.sync="perkVisible" :row="currentRow" /> -->
  </div>
</template>

<script>
import AddPosition from "./AddPosition";
import MyTable from "@/components/Table";
import Search from "@/components/Search";
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import { posTypes } from "@/utils/common";
export default {
  components: {
    AddPosition,
    MyTable,
    Search,
  },
  data () {
    return {
      dialogVisible: false,
      stateDialogVisible: false,
      submitLoading: false,
      sortPara: {
        data: "",
        controller: "posts",
        action: "postsSort",
        callback: "getPostsData",
      },
      tableName: "PositionManageTable",
      tableConfig: [
        {
          field: "projectName",
          label: "计划名称",
          flag: true,
          minWidth: 170,
          align: "center",
        },
        {
          field: "enterpriseShortName",
          label: "企业简称",
          flag: true,
          align: "center",
          minWidth: 170,
        },
        {
          field: "positionName",
          label: "职位名称",
          align: "center",

          flag: true,
          minWidth: 170,
        },
        {
          field: "positionType",
          label: "职位类别",
          // style: 1,
          flag: true,
          align: "center",

          minWidth: 90,
        },
        {
          field: "remunerationType",
          label: "类型",
          slotName: "remunerationType",
          align: "center",
          width: 80,
          flag: true,
        },
        {
          field: "remunerationLevel",
          label: "收入",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "isPublic",
          label: "公共职位",
          slotName: "isPublic",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "dateTimeFrom",
          label: "生效日期",
          slotName: "dateTimeFrom",
          align: "center",
          width: 160,
          flag: true,
        },
        {
          field: "dateTimeTo",
          label: "结束日期",
          slotName: "dateTimeTo",
          align: "center",
          width: 160,
          flag: true,
        },
        {
          field: "refreshDate",
          label: "刷新时间",
          minWidth: 50,
          slotName: "refreshDate",
          align: "center",

          flag: true,
          width: 160,
        },
        {
          label: "基本操作",
          slotName: "operation",
          width: 330,
          align: "center",
          flag: true,
          fixed: "right",
        },
      ],
      currentRow: null,
      isShow: false,
      batchNum: 1,
      tabIndex: 4,
      tabList: [],
      roleList: [],
      startDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择结束日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeTo) return false;

          // 转换结束日期为 Date 对象，清除时间部分
          const endDate = new Date(this.form.dateTimeTo);
          endDate.setHours(0, 0, 0, 0);

          // 禁用：结束日期及之后的所有日期（确保开始 < 结束）
          return date.getTime() >= endDate.getTime();
        }
      },
      // 结束日期选择器配置：禁用 <= 开始日期的日期
      endDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择开始日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeFrom) return false;

          // 转换开始日期为 Date 对象，清除时间部分
          const startDate = new Date(this.form.dateTimeFrom);
          startDate.setHours(0, 0, 0, 0);

          // 禁用：开始日期及之前的所有日期（确保结束 > 开始）
          return date.getTime() <= startDate.getTime();
        }
      },
      form: {},
      rules: {
        time: [
          {
            required: true,
            message: "请选择生效期",
            trigger: ["blur", "change"],
          },
        ],
        isStop: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
        dateTimeTo: [
          {
            required: true,
            message: "请选择结束日期",
            trigger: ["blur", "change"],
          },
        ],
        isPublic: [
          {
            required: true,
            message: "请选择公共职位",
            trigger: ["blur", "change"],
          },
        ],
        dateTimeFrom: [
          {
            required: true,
            message: "请选择生效日期",
            trigger: ["blur", "change"],
          },
        ],
      },
      factoryId: "",
      positionId: "",
      perkId: "",
      companyList: [],
      perkVisible: false,
      Ids: [],
      QRVisible: false,
      currentPage: 1,
      imgPath: '',
      pageSize: 10,
      total: 0,
      loading: false,
      remunerationTypeList: [
        { label: "日薪", id: 1 },
        { label: "周薪", id: 2 },
        { label: "月薪", id: 3 },
        { label: "小时工资", id: 4 },
        { label: "计件工资", id: 5 },
        { label: "面议", id: 6 },
      ],
      delPara: {
        data: "",
        controller: "PositionInfo",
        action: "Delete",
        callback: "getPostsData",
      },
      typeList: posTypes,
      tableData: [],
      searchForm: {},
      addPositionDrawerShow: false,
      operation: "",
      postInfo: null,
      postDetail: null,
      customerInfo: null,
      companyId: "",
      tableHeight: "",
      userAutoIntId: '',
      CompanyAutoIntId: '',
    };
  },
  computed: {},
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  mounted () {
    this.getCompanyList();
    this.getPostsData();
    // this.getPositionList();
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
    let detail = JSON.parse(window.localStorage.getItem("userInfo"));
    let Companydetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userAutoIntId = detail.autoIntId;
    this.CompanyAutoIntId = Companydetail.autoIntId;
  },
  methods: {
    handleDateChange () {
      const { dateTimeFrom, dateTimeTo } = this.form;
      // 两个日期都已选择时才校验
      if (dateTimeFrom && dateTimeTo) {
        const start = new Date(dateTimeFrom);
        const end = new Date(dateTimeTo);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        // 如果开始 >= 结束，清空后选择的那个日期（谁后变就清空谁）
        // 这里简化逻辑：直接清空结束日期（也可根据业务调整为清空开始日期）
        if (start >= end) {
          this.form.dateTimeTo = '';
          // 若想清空开始日期，可改为：this.form.dateTimeFrom = '';
        }
      }
    },
    openDialog (row) {
      this.QRVisible = true;
      this.$nextTick(() => {
        this.qrcode(row.intId);
      });
    },
    posType (value) {
      for (let index = 0; index < this.remunerationTypeList.length; index++) {
        if (this.remunerationTypeList[index].id == value) {
          return this.remunerationTypeList[index].label;
        }
      }
    },
    addPos () {
      this.addPositionDrawerShow = true;
      this.operation = "add";
    },
    // 获取职位类别
    getPositionList () {
      let sendData = {
        loading: false,
      };
      this.$api.posts.PositionTypePage(sendData).then((res) => {

        if (res.error === false) {
          this.typeList = res.data.data;
        }
      });
    },
    resetForm () {
      this.form = {};
      this.$refs.form.clearValidate();
    },
    openDialog (row) {

      this.QRVisible = true;
      this.$nextTick(() => {
        this.qrcode(row.intId);
      });
    },
    //生成二维码
    qrcode (id) {
      let sendData = {
        page: "pages/packageC/position/job-detail",
        check_path: false,
        width: 150,
        scene: "posId=" + id,
      };
      this.GetUnlimitedQRCode(sendData).then((res) => {
        this.imgPath = "data:image/png;base64," + res;
        this.submitLoading = false;
        this.QRVisible = true;
      });
    },
    changeState (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.$confirm(`${this.batchNum == 1 ? '批量发布' : '批量公共职位'}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        }).then(() => {
          if (this.batchNum == 1) {
            let sendData = {
              idList: this.Ids,
              dateTimeFrom: this.form.dateTimeFrom,
              dateTimeTo: this.form.dateTimeTo,
            };
            this.submitLoading = true;
            this.$api.PositionInfo.Release(sendData).then((res) => {
              if (res.error === false) {
                this.$message.success("更新成功");
                this.stateDialogVisible = false;
                this.getPostsData();
              }
              this.submitLoading = false;
            });
          } else {
            let sendData = {
              idList: this.Ids,
              isPublic: this.form.isPublic,
            };
            this.submitLoading = true;
            this.$api.PositionInfo.SetIsPublic(sendData).then((res) => {
              if (res.error === false) {
                this.$message.success("更新成功");
                this.stateDialogVisible = false;
                this.getPostsData();
              }
              this.submitLoading = false;
            });
          }

        });
      });
    },
    // 批量更改状态
    batchState (num) {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.batchNum = num;
      this.stateDialogVisible = true;
    },
    // 后台获取排序
    sortChange (column) {
      if (this.sortType == "custom") {
      }
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    // 获取高度
    getHeight (height) {
      this.tableHeight = height;
    },
    singleEdit (value, field, id) {
      let sendData = {
        id: id,
      };
      sendData[field] = value;
      this.$api.posts.increasePosts(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存职位信息成功");
        } else {
          this.$message.error("保存职位信息失败");
        }
      });
    },
    // 添加补贴
    addperk (formName) {
      if (
        !this.form.tian ||
        !this.form.direcrtMoney ||
        !this.form.indirectMoney
      ) {
        this.$message.error("输入框不能为空");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          factoryId: this.form.factoryId,
          positionId: this.form.positionId,
          DayNumber: this.form.tian,
          subsidyMoney: this.form.direcrtMoney,
          parentSubsidyMoney: this.form.indirectMoney,
          startDate: this.form.time[0],
          endDate: this.form.time[1],
          isStop: this.form.isStop,
        };
        if (this.form) {
          sendData.id = this.form.id;
        }
        this.$api.posts.addPerk(sendData).then((res) => {
          if (res.error == false) {
            this.dialogVisible = false;
            this.form = {};
            this.$message.success("设置成功");
          }
        });
      });
    },
    inputChange (value, field, id) {
      this.singleEdit(value, field, id);
      console.log(value, field, id);
    },
    selectChange (value, field, id) {
      console.log(value, field, id);
    },
    // 刷新时间
    UpdateTime (id) {
      this.$confirm("是否确认刷新时间？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 刷新时间
          this.$api.PositionInfo.Refresh({ id }).then((res) => {
            if (res.error === false) {
              this.getPostsData();
              this.$message.success("刷新成功");
            }
          });
        })
        .catch(() => { });
    },
    //打开补贴设置
    perkManage (row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
      this.$set(this.form, "factoryId", row.customerId);
      this.$set(this.form, "positionId", row.id);
      const sendData = {
        positionId: row.id,
      };
      this.$api.posts.getPerk(sendData).then((res) => {
        if (!res.error) {
          if (res.data.data) {
            let data = res.data.data[0];
            this.$set(this.form, "tian", data.dayNumber);
            this.$set(this.form, "direcrtMoney", data.subsidyMoney);
            this.$set(this.form, "indirectMoney", data.parentSubsidyMoney);
            this.$set(this.form, "department", data.department);
            this.$set(this.form, "time", [data.startDate, data.endDate]);
            this.$set(this.form, "isStop", data.isStop);

            this.$set(this.form, "id", data.id);
          }
        }
      });
    },
    // 获取企业列表
    getCompanyList () {
      let sendData = {
        loading: false,
      };
      this.$api.EnterpriseInfo.List(sendData).then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
          this.tableConfig[0].list = res.data;
        }
      });
    },
    // 获取职位数据
    getPostsData () {
      this.loading = true;
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        wheres: [
          {
            name: "keyword",
            value: this.searchForm.keyWord,
            expressionType: "Like",
          },
          {
            name: "enterpriseId",
            value: this.searchForm.enterpriseId,
            expressionType: "Equal"
          },
          {
            name: "remunerationType",
            value: this.searchForm.remunerationType ? String(this.searchForm.remunerationType) : "",
            expressionType: "Equal",
          },
          {
            name: "releaseType",
            value: this.searchForm.releaseType,
            expressionType: "Equal",
          },
          {
            name: "positionType",
            value: this.searchForm.positionType,
            expressionType: "Equal",
          },

        ],
      };
      // 已修改 获取数据
      this.$api.PositionInfo.PageData(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.count;
        }
      });
    },

    // 获取职位详情
    getPostDetails (id) {
      return new Promise((resolve, reject) => {
        // 已修改 获取数据详情
        this.$api.PositionInfo.Detail({ id }).then((res) => {
          if (res.error === false) {
            this.postInfo = res.data;
            this.postDetail = res.data;
            resolve(res);
          } else {
            this.$message.error("职位信息获取失败");
            reject(false);
          }
        });
      });
    },
    // 修改职位信息
    editPost (row) {
      console.log(row);
      this.getPostDetails(row.id).then((res) => {
        if (res) {
          this.addPositionDrawerShow = true;
          this.operation = "edit";
        }
      });
    },

    tabItemChange (index, value) {
      this.tabIndex = index;
      if (value === 0) {
        this.$set(this.searchForm, "state", "");
      } else {
        this.$set(this.searchForm, "state", value);
      }
      this.getPostsData();
    },

    beforeHandleCommand (index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },
    handleCommand (command) {
      switch (command.command) {
        case "UpdateTime":
          this.UpdateTime(command.row);
          break;
        case "perkManage":
          this.perkManage(command.row);
          break;
      }
    },

    // Naze 单个删除职位信息
    deletePosition (id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const formData = new FormData();
          formData.append("id", id);
          this.$api.posts.deleteposition(formData).then((res) => {
            if (res.error == false) {
              this.getPostsData();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="less">
.el-dropdown-link {
  margin-right: 10px;
}
.lin-btn {
  margin-left: 5px;
}
.position-list {
  .table-section {
    width: calc(100%);
    // height: calc(100vh - 155px);
  }

  .search {
    .el-date-editor .el-range-separator {
      width: 10%;
    }
    .el-input--small .el-input__inner {
      height: 34px;
    }
  }
}

.post-state-list {
  position: absolute;
  width: 100px;
  right: -120px;
  padding: 0 15px;
  background-color: #fff;
}
.hint {
  color: red;
}
</style>
